export default {
  "header": {
    "CHANGE_PASSWORD": "更改密码",
    "CHANGE_STATION": "切换工位号码",
    "CHANGE_SETTING": "设置",
    "CLICK_ON": "点击展开",
    "CLICK_ON_THE_FOLD": "点击收起",
    "CURRENT_PASSWORD": "当前密码",
    "FAILED_UPDATE_TASK_LIST": "更新任务列表失败",
    "LOGOUT": "登出",
    "MSG_ENTER_CURRENT_PASSWORD": "请输入当前密码",
    "MSG_ENTER_NEW_PASSWORD": "请输入新密码",
    "MSG_NEW_PASSWORD_NOT_MATCH": "新密码不匹配",
    "MSG_PASSWORD_UPDATED": "您的密码已成功更新，请使用新密码登录",
    "NEW_PASSWORD": "新密码",
    "NEW_PASSWORD_AGAIN": "确认新密码",
    "SELECT_CLIENT_TO_SWITCH": "选择客户",
    "SWITCH_CLIENT": "切换客户端",
    "SWITCHED_TO_CLIENT": "切换到客户",
    "TASK_LIST": "任务列表",
    "UPDATE_PASSWORD": "更新密码",
    "USER_PROFILE": "用户配置",
    "DIM_WEIGHT_ADDRESS": "Dim Weight 机位址",
    "MSG_SETTING_UPDATED_SUCCESS": "设置保存成功, 请刷新页面确保更新套用",
    "WEIGHT_MODE": "称重模式",
    "WEIGHT_MODE_NONE": "无 (手动输入)",
    "WEIGHT_MODE_LOCAL": "本地 (WebApp Hardware Bridge)",
    "WEIGHT_MODE_DIM_WEIGHT": "Dim Weight 机 (内网)",
    "SAVE": "保存"
  },
  "login": {
    "EMAIL": "电邮",
    "ERROR_EMPTY_PASSWORD": "密码不能为空",
    "INFO_LOGIN_SUCCESS": "登录成功",
    "LOGIN_INCORRECT": "登录失败, 使用者名称或密码不正确",
    "MFA_CODE": "验证码",
    "MFA_INVALID": "不正确的验证码, 请重新输入",
    "MFA_REQUIRED": "需要输入验证码, 请透过登记的手机 SMS 或 OTP 接收",
    "PASSWORD": "密码",
    "RESET": "重设",
    "SUBMIT": "登入",
    "SWITCHING_CLIENT": "正在切换客户，请稍候...",
    "USERNAME": "用户名"
  },
  "menu": {
    "DASHBOARD": "仪表板",
    "INBOUND_AND_OUTBOUND": "出入库统计",
    "OPERATION_INBOUND": "入仓扫描",
    "OPERATION_MANUAL_SORT": "手动分拣入仓",
    "OPERATION_LOCKER_RETURN_INBOUND": "自助柜退件回件入仓",
    "PY_RETURN_INBOUND":"五联单回件入仓",
    "DEST_PICKUP_INBOUND":"目的地取件分拣入仓",
    "OPERATION_MANUAL_OUTBOUND": "手动分拣出仓",
    "OPERATION_MANUAL_CLOSE_BOX": "封箱及移交",
    "OPERATION_OUTBOUND": "出库",
    "OPERATION_RETURN": "回仓扫描",
    "PROBLEM_WAREHOUSE":'问题件仓存',
    "OPERATION_CONSOLIDATION": "集货",
    "OPERATION_CHECK": "查單",
    "VOLUME_BY_SORT_CODE": "路线货量统计",
    "MANUAL_SORTING": "手動分揀",
    "AUTO_SORTER": "自動分揀機",
    "AUTO_SORTER_DASHBOARD": "仪表板",
    "AUTO_SORTER_CONTROL_PANEL": "操作面板",
    "AUTO_SORTER_PROFILES": "分揀邏輯",
    "DHL_ITEM_SORTING":"DHL項目分揀",
    "INBOUND_PACKAGE_HANDING":"入庫包裹處理",
    "COLLECTION":"攬收",
    "PY_SORT_INBOUND":"五联单分拣入仓",
    "HANDOVER_REPORT":"報告",
    "ORDERINFO":"查訂單資料",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh-CN.js